import styled from 'styled-components';

const StyledGridVirtualShowroom = styled.div`
  background-color: #000;
  padding: 0 64px;
  margin-bottom: ${ props => props.theme.components_spacing_desk.xxlarge}px;
  background-color: #FFF;
  height: auto;
  overflow: hidden;
  .grid--shelfzone{
    position: relative;
    width: 100%;
    padding-top: ${ props => props.theme.components_spacing_desk.xlarge}px;
  }
  .center--paragraph{
    margin-bottom: 0;
  }
  .grid-wrap--shelfzone{
    position: relative;
    width: 100%;
  }
  .grid-row--shelfzone{
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: ${ props => props.theme.components_spacing_desk.xlarge}px;
  }
  .grid-col--shelfzone {
    position: relative;
    flex: 0 0 49%;
    overflow: hidden;
  }
  .grid-col--shelfzone img {
    display: block;
    width: 100%;
  }
  .grid-col-text--shelfzone {
    flex: 0 0 41.67%;
  }
  .grid-col-text--shelfzone h6 {
    padding: 24px 0;
  }
  .grid-col-text--shelfzone p.number {
    opacity: .5;
  }
  @media screen and (max-width: 1439px){
    padding: 0 40px;
    margin-bottom: ${ props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 1023px){
    .grid--shelfzone{
      padding-top: ${ props => props.theme.components_spacing_tablet.xlarge}px;
    }
    .grid-row--shelfzone{
      padding-top: ${ props => props.theme.components_spacing_tablet.xlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    padding: 0 24px;
    margin-bottom: ${ props => props.theme.components_spacing_mobile.xxlarge}px;
    .grid--shelfzone{
      padding-top: ${ props => props.theme.components_spacing_mobile.xlarge}px;
    }
    .grid-row--shelfzone{ 
      padding-top: ${ props => props.theme.components_spacing_mobile.xlarge}px;
      flex-direction: column;
    }
    .grid-col--shelfzone{
      width: 100%;
      flex: 1 0 100%;
    }
    .grid-row--shelfzone img {
      margin-top: 24px;
    }
    .grid-reverse {
      flex-direction: column-reverse;
    }
  }
`;

export {
  StyledGridVirtualShowroom,
};

